<template>
  <div class="cutting-edge-news-search">
    <div class="search-content">
      <el-input
        placeholder="请输入内容"
        suffix-icon="el-icon-search"
        v-model.trim="keywords"
        @keyup.enter.native="handleSearch"
      >
      </el-input>
      <!-- 根据关键词搜索的内容区 -->
      <div class="news-content">
        <!-- <div v-for="(item, index) in dataList" :key="index" style="margin-top: 40px">
          <span>{{ item.title }}</span>
          <div class="information">
            <img :src="item.img" alt="" v-if="item.img !== ''" />
            <p>{{ item.content }}</p>
          </div>
        </div> -->
        <!-- 有搜索记录才出来 -->
        <div class="history" v-if="pastHistory">
          <div class="hisText">历史记录</div>
          <div style="max-height: 80px; overflow: auto;">
            <el-tag
              style="margin: 10px 10px 0 0"
              v-for="(item, index) in searchRefList"
              :key="index"
              @click="clickHistory(item, index)"
              closable
              @close="deleteHis(index)"
              :title="item"
              size="small"
            >
              {{ item }}
            </el-tag>
          </div>
        </div>
        <div class="hisText_right">
          <span>排序：</span>
           <span
                @click="timeSort"
                :class="{ blue: activeSort == 'timeSort' }"
                >时间<i
                  v-if="activeSort == 'timeSort'"
                  :class="{
                    'el-icon-bottom': !this.orderId,
                    'el-icon-top': this.orderId,
                  }"
                ></i
              ></span>
              <span
                @click="relevanceSort"
                :class="{ blue: activeSort == 'relevanceSort' }"
                >相关度<i
                  v-if="activeSort == 'relevanceSort'"
                  :class="{
                    'el-icon-bottom': !this.orderId,
                    'el-icon-top': this.orderId,
                  }"
                ></i
              ></span>
             <span
                @click="synthesisSort"
                :class="{ blue: activeSort == 'synthesisSort' }"
                >正负点<i
                  v-if="activeSort == 'synthesisSort'"
                  :class="{
                    'el-icon-bottom': !this.orderId,
                    'el-icon-top': this.orderId,
                  }"
                ></i
              ></span>
        </div>
        <InformationList
          :information-data="newsData"
          :scale="{ width: '100%' }"
          :search-name="lastSearchName"
        />
        <el-pagination
          style="text-align: center"
          small
          @current-change="handlePageChange"
          :current-page="currentPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 热点新闻 -->
    <div class="hot-news" v-show="false">
      <h3>热点新闻</h3>
      <ul v-for="(item, index) in hotNewList" :key="index">
        <li>
          <span>{{ item.id }}</span>
          <p>{{ item.title }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import InformationList from "@/components/InformationList";
import { request } from "@/utils/request";
export default {
  props: {
    defaultValue: {
      type: String,
      default: "",
    },
  },
  components: {
    InformationList,
  },
  data() {
    return {
      activeSort: "",
      orderId: 0,
      searchRefList: [],
      pastHistory: true, //搜索记录
      keywords: this.defaultValue,
      lastSearchName:"",
      currentPage: 1,
      pageSize: 15,
      total: 0,
      newsData: [],
      dataList: [
        {
          title: "世界上最大的海洋是书吗？世界上最大的海洋是书吗?",
          content:
            "世界上最大的海洋是书吗？世界上最大的海洋是书吗？世界上最大的海洋是书吗？",
          img: "",
        },
        {
          title:
            "世界上最大的海洋是书吗？世界上最大的海洋是书吗？世界上最大的海洋是书吗？世界上最大的海洋是书吗？世界上最大的海洋是书吗？世界上最大的海洋是书吗？世界上最大的海洋是书吗？世界上最大的海洋是书吗？世界上最大的海洋是书吗？",
          content:
            "世界上最大的海洋是书吗？世界上最大的海洋是书吗？世界上最大的海洋是书吗？世界上最大的海洋是书吗？世界上最大的海洋是书吗？世界上最大的海洋是书吗？世界上最大的海洋是书吗？世界上最大的海洋是书吗？世界上最大的海洋是书吗？",
          img: require("../../assets/image/news.png"),
        },
      ],
      hotNewList: [
        {
          id: 1,
          title: "xxxxxx",
        },
        {
          id: 2,
          title: "xxxxxx",
        },
        {
          id: 3,
          title: "xxxxxx",
        },
      ],
    };
  },
  mounted() {
    let localhistory = localStorage.getItem("datailHistory");
    localhistory = JSON.parse(localhistory);
    this.searchRefList = localhistory;
    this.handleSearch();
  },
  methods: {
     // 时间排序
    timeSort() {
      this.activeSort = "timeSort";
      // datetime
      this.order = "0";
      this.orderId = Number(!this.orderId);
      this.handleSearch();
      console.log(this.orderId);
    },
    // 相关度排序
    relevanceSort() {
      this.activeSort = "relevanceSort";
      // relevance
      this.order = "1";
      this.orderId = Number(!this.orderId);
      this.handleSearch();
    },
    // 正负点
    synthesisSort() {
      this.activeSort = "synthesisSort";
      // comprehensive
      this.order = "2";
      this.orderId = Number(!this.orderId);
      this.handleSearch();
    },
    handleSearch() {
      if(!this.activeSort){ // 默认没有点击排序
         var params = {
          category_code: "1.",
          page_size: this.pageSize,
          page_to: this.currentPage,
          search: this.keywords,
      }
        }else{
          var params = {
            order_option:Number(this.order), // 类型
            order_id:Number(this.orderId), // 升降
            category_code: "1.",
            page_size: this.pageSize,
            page_to: this.currentPage,
            search: this.keywords,
        }
      }
     
      this.lastSearchName= this.keywords
      request.region_information
        .find("", params)
        .then((res) => {
          this.newsData = [];
          const { records } = res.data?.data;
          if(records.length<1){
            this.$message.info("暂无该信息!")
          }
          records.forEach((b) => {
            this.newsData.push({
              cardTitle: b.information.title,
              cardContent: b.information.short_content,
              href: b.information.link,
              the_time: b.information.the_time,
            });
          });
           this.$message({
              type: "success",
              message: "检索成功",
          });
          this.total = res.data.data.total_records;
        });
      if (!this.keywords) {
        return;
      }
      this.saveHistory();
    },
    handlePageChange(currentPage) {
      this.currentPage = currentPage;
      this.handleSearch(this.keywords);
    },
    //去重方法封装
    unique(arr) {
      return arr.filter(function (item, index, arr) {
        return arr.indexOf(item, 0) === index;
      });
    },
    // 排序
    saveHistory() {
      if(this.searchRefList !== null) {
          this.searchRefList.unshift(this.keywords);
        }else{
          this.searchRefList = []
          this.searchRefList.push(this.keywords);
        }
      
      this.searchRefList = this.unique(this.searchRefList);

      if (this.searchRefList.length > 10) {
        //最多保存10条
        this.searchRefList = this.searchRefList.slice(0, 10);
      }
      localStorage.setItem("datailHistory", JSON.stringify(this.searchRefList)); //存localStorage
      this.pastHistory = true;
    },
    //点击删除记录
    deleteHis(index) {
      if (isNaN(index) || index >= this.searchRefList.length) {
        return false;
      }
      this.searchRefList.splice(index, 1);

      localStorage.setItem("datailHistory", JSON.stringify(this.searchRefList)); //保存删除后的新数组
      if (this.searchRefList.length === 0) {
        this.pastHistory = false;
      }
    },
    // 点击历史记录直接搜索
    clickHistory(data) {
      this.keywords = data;
      this.handleSearch();
    },
  },
};
</script>

<style lang="scss">
$fontColor: #eee;
.cutting-edge-news-search {
  width: 80%;
  height: calc(100vh - 100px);
  margin: 0 auto;
  display: flex;
  .search-content {
    width: 60%;
    height: 100%;

    & > .el-input {
      margin: 10px 0;
      .el-input__inner {
        color: $fontColor;
        background-color: transparent;
        border-radius: 15px;
      }
    }
    .news-content {
      width: 100%;
      height: calc(100% - 70px);
      background-color: rgba(255, 255, 255, 0.1);
      border-radius: 10px;
      border: 2px solid rgba(125, 115, 115, 0.2);
      padding: 10px;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: space-evenly;
      // span {
      //   font-size: 16px;
      //   text-decoration: underline;
      //   display: inline-block;
      //   max-width: 410px;
      //   overflow: hidden;
      //   text-overflow: ellipsis;
      //   white-space: nowrap;
      // }
      // .information {
      //   display: flex;
      //   align-items: center;
      //   margin-top: 10px;
      //   img {
      //     margin: 0 5px;
      //     width: 100px;
      //     height: 70px;
      //   }
      //   p {
      //     word-break: break-all;
      //     text-overflow: ellipsis;
      //     overflow: hidden;
      //     display: -webkit-box;
      //     -webkit-line-clamp: 2;
      //     -webkit-box-orient: vertical;
      //     padding-right: 10px;
      //     text-indent: 2em;
      //   }
      // }
    }
  }
  .hot-news {
    width: 40%;
    height: calc(100% - 70px);
    margin-top: 70px;
    margin-left: 30px;
    background-color: #fff;
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    border: 2px solid rgba(125, 115, 115, 0.2);
    padding: 30px;
    box-sizing: border-box;
    ul {
      margin-top: 30px;
      li {
        display: flex;
        align-items: center;
        span {
          margin-right: 10px;
        }
        p {
          font-size: 16px;
        }
      }
    }
  }
}
.hisText_right{
  margin:5px 0;
  width: 99%;
  display: flex;
  justify-content: end;
   span {
    margin-left: 10px;
    cursor: pointer;
    font-size: 10px;
  }
   &  span {
      margin-left: 10px;
      cursor: pointer;
      font-size: 10px;
    }
    &  span:nth-child(1),
     span:nth-last-child(1) {
      cursor: text;
    }
}
.blue {
  color:yellow;
}
</style>
